import axios from 'axios'

export default {
  load (participantId) {
    return axios.get('participant/' + participantId + '/payments')
  },
  add (payment) {
    return axios.post('payment/' + payment.participantId, {
        participantId: payment.participantId,
        date: payment.date,
        amount: payment.amount
    })
  },
  delete (payment) {
    return axios.delete('payment/' + payment.id)
  }
}
